// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"stepper-styles_containerVerticalStepper__-SySV","verticalStepperSxElement":"stepper-styles_verticalStepperSxElement__F-hmb"};